import React, { useEffect, useState, useRef } from "react";
import AOS from "aos"; // Import AOS for animations
import "aos/dist/aos.css"; // Import AOS styles

const Stats = () => {
  const [counts, setCounts] = useState({
    compressorWarranty: 0,
    deviceWarranty: 0,
    afterSales: 0,
  });

  const [startCounting, setStartCounting] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    AOS.init();

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setStartCounting(true);
        }
      },
      { threshold: 0.5 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!startCounting) return;

    const targetCounts = {
      compressorWarranty: 60,
      deviceWarranty: 24,
      afterSales: 144,
    };

    const duration = 4000; // Total duration of the countdown in ms
    const intervalTime = 40; // Time between updates in ms

    // Calculate total increments required
    const totalSteps = duration / intervalTime;

    // Calculate the increment for each count
    const increments = {
      compressorWarranty: Math.ceil(targetCounts.compressorWarranty / totalSteps),
      deviceWarranty: Math.ceil(targetCounts.deviceWarranty / totalSteps),
      afterSales: Math.ceil(targetCounts.afterSales / totalSteps),
    };

    const interval = setInterval(() => {
      setCounts((prevCounts) => {
        const newCounts = { ...prevCounts };

        for (const key in targetCounts) {
          if (newCounts[key] < targetCounts[key]) {
            newCounts[key] += increments[key];
          }
          if (newCounts[key] > targetCounts[key]) {
            newCounts[key] = targetCounts[key];
          }
        }

        return newCounts;
      });
    }, intervalTime);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, duration);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [startCounting]);

  return (
    <div ref={statsRef} className="statsContainer">
      <h1 data-aos="fade-up" data-aos-duration="2000">
        کنار هم، مطمئن‌تریم
      </h1>
      <div className="statsList">
        <div style={{minWidth:"180px"}}>
          <p>
            <span>{counts.compressorWarranty}</span> ماه
          </p>
          ضمانت کمپرسور
        </div>
        <hr />
        <div  style={{minWidth:"180px"}}>
          <p>
            <span>{counts.deviceWarranty}</span> ماه
          </p>
          ضمانت دستگاه
        </div>
        <hr />
        <div  style={{minWidth:"180px"}}>
          <p>
            <span>{counts.afterSales}</span> ماه
          </p>
          خدمات پس از فروش
        </div>
      </div>
    </div>
  );
};

export default Stats;
